/** Предложение ярлыка на экран телефона — представление без стора, всё приходит пропсами. */
import { Button, TAP_GUARD_MS, WindowShell } from "../kit";
import { useT } from "../../../app";

export interface HomeScreenViewProps {
  onAdd(): void;
  onDecline(): void;
}

export function HomeScreenView({ onAdd, onDecline }: HomeScreenViewProps) {
  const t = useT();
  return (
    <WindowShell kind="homeScreen" title={t("win.homeScreen.title")} guardMs={TAP_GUARD_MS}>
      <p class="win-text" data-testid="home-screen-text">
        {t("win.homeScreen.text")}
      </p>
      <div class="win-actions">
        <Button tone="green" onClick={onAdd} data-testid="home-screen-add">
          {t("win.homeScreen.add")}
        </Button>
        <Button tone="link" onClick={onDecline} data-testid="home-screen-decline">
          {t("win.homeScreen.decline")}
        </Button>
      </div>
    </WindowShell>
  );
}
